import { render, staticRenderFns } from "./RemovePlpDialog.vue?vue&type=template&id=15310090"
import script from "./RemovePlpDialog.ts?vue&type=script&lang=ts&external"
export * from "./RemovePlpDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./RemovePlpDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports